import axios from "axios";
import { refreshPasswordManagerToken } from "./refreshPasswordManagerToken";

type Dispatch = (action: unknown) => unknown;

export const withPasswordManagerRefresh = async <T>(dispatch: Dispatch, request: () => Promise<T>): Promise<T> => {
	try {
		return await request();
	} catch (error: unknown) {
		if (axios.isAxiosError(error) && error.response?.status === 401) {
			await (dispatch as (action: unknown) => { unwrap: () => Promise<unknown> })(refreshPasswordManagerToken()).unwrap();
			return request();
		}
		throw error;
	}
};
